import React from "react";
import TextBlock from "../TextBlock/TextBlock";
import ContractSign from "./ContractSign";
import PdfDownload from "../PdfDownload";
import PositionList from "../Positions/PositionList";
import SubjectDate from "../SubjectDate";
import ContractHead from "./ContractHead";
import FooterContact from "../FooterContact";
import { ResourceContextProvider } from "../../Service/Context/ResourceContext";
import { Space } from "@mantine/core";
import VatNote from "../Document/VatNote";
import { useLingui } from "@lingui/react";
import {
  getDocumentTranslator,
  translateGeneratedDocumentText,
} from "../Document/documentLanguage";
import {
  CancelFormSubmissionAction,
  CancelledFormSubmissionNotice,
} from "../FormSubmissionCancellation";

const Contract = ({
  resource,
  document,
  formSubmission,
  values,
  handleChange,
  reloadFormSubmission,
  patchSubmissionValue,
}) => {
  const { i18n } = useLingui();
  const t = getDocumentTranslator(i18n, document.language);
  const isCancelled =
    formSubmission.cancelledAt !== null &&
    formSubmission.cancelledAt !== undefined;
  const isSigned =
    formSubmission.lastSubmitted !== null &&
    formSubmission.lastSubmitted !== undefined;

  return (
    <ResourceContextProvider
      resourceId={resource.id}
      contactId={document.contactId}
      customerContactId={document.customerId}
    >
      {isCancelled && (
        <CancelledFormSubmissionNotice
          cancelledAt={formSubmission.cancelledAt}
          documentType="CONTRACT"
          t={t}
        />
      )}
      <ContractHead contract={document} resource={resource} />
      <SubjectDate
        subject={translateGeneratedDocumentText(document.subject, t)}
        date={document.date}
      />
      {document.aboveTextBlocks.map((textBlock, index) => {
        return (
          <TextBlock key={"aboveTextBlock" + index} textBlock={textBlock} />
        );
      })}
      <PositionList
        resourceId={resource.id}
        taxType={document.taxType}
        positions={document.positions}
        positionGroups={document.positionGroups}
        isSummable={document.summable}
        formSubmission={formSubmission}
        values={values}
        handleChange={handleChange}
        patchSubmissionValue={patchSubmissionValue}
        document={document}
      />
      {document.positions && document.positions.length !== 0 && (
        <>
          <Space h={30} />
          <VatNote language={document.language} />
        </>
      )}
      {document.belowTextBlocks.map((textBlock, index) => {
        return (
          <TextBlock key={"belowTextBlock" + index} textBlock={textBlock} />
        );
      })}
      <FooterContact contract={document} language={document.language} />
      {document.contractSign !== "NONE" && !isCancelled && (
        <ContractSign
          contract={document}
          formSubmission={formSubmission}
          customerSignType={document.customerSignType}
          patchSubmissionValue={patchSubmissionValue}
          values={values}
          handleChange={handleChange}
          resource={resource}
          reload={reloadFormSubmission}
        />
      )}
      {isSigned && !isCancelled && (
        <>
          <Space h="xl" />
          <PdfDownload
            formSubmission={formSubmission}
            text={t("contractDownloadButton")}
          />
        </>
      )}
      {!isCancelled && isSigned && (
        <CancelFormSubmissionAction
          documentType="CONTRACT"
          formSubmissionId={formSubmission.id}
          lastSubmitted={formSubmission.lastSubmitted}
          reloadFormSubmission={reloadFormSubmission}
          t={t}
        />
      )}
    </ResourceContextProvider>
  );
};

export default Contract;
